'use client';

import { Separator, cn } from '@baseball-near-you/ui';
import type { ContentTextEditor } from '@bb/sanity.types';
import { toHTML } from '@portabletext/to-html';
import { Dot } from 'lucide-react';
import { useState } from 'react';
import {
  tableOfContentsFrom,
  tableOfContentsPlaceholderComponents,
} from './utils/tableOfContentUtils';

export function TableOfContents({ content }: { content: ContentTextEditor }) {
  const [isOpen, setIsOpen] = useState(false);
  const { tableOfContents } = tableOfContentsFrom(
    toHTML(content, {
      components: tableOfContentsPlaceholderComponents as any,
    })
  );

  return tableOfContents.length > 0 ? (
    <div className="mt-3 flex w-full flex-col">
      <button
        type="button"
        className="title flex h-7 items-center text-left font-bold! text-blue-500!"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div
          className={cn(
            'mr-2 text-2xl transition-all',
            isOpen ? 'mb-0.5 rotate-45' : 'rotate-0'
          )}
        >
          +
        </div>
        Index
      </button>
      <div className={cn(isOpen ? 'block w-full' : 'hidden')}>
        <>
          {tableOfContents.map((item, i) => {
            return (
              <a
                key={`${item.tag}-${i}`}
                href={`#${item.tag}`}
                className="flex items-center"
              >
                <Dot size={22} className="mr-0.5" /> {item.text}
              </a>
            );
          })}

          <Separator className="mt-2 w-full" orientation="horizontal" />
        </>
      </div>
    </div>
  ) : null;
}
